/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BucketLifecycleRule } from './bucketLifecycleRule';


export interface S3Bucket { 
    name?: string;
    region_id?: string;
    create_time?: Date;
    isEmpty?: boolean;
    lifecycle_rules?: Array<BucketLifecycleRule>;
}

